import { render } from "./CardSimple.vue?vue&type=template&id=d3b352d4&scoped=true"
import script from "./CardSimple.vue?vue&type=script&lang=js"
export * from "./CardSimple.vue?vue&type=script&lang=js"

import "./CardSimple.vue?vue&type=style&index=0&id=d3b352d4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b352d4"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
